import { render } from "./ProjectPublicationHistoryListItemMediaItemsVideo.vue?vue&type=template&id=8cd972d2&scoped=true"
import script from "./ProjectPublicationHistoryListItemMediaItemsVideo.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemMediaItemsVideo.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListItemMediaItemsVideo.vue?vue&type=style&index=0&id=8cd972d2&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd972d2"]])

export default __exports__